import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";

import { Icon as EworkitIcon, IIconProps as IEworkitIconProps, TStyleTextColor } from "@/eworkitComponents";

import { buildTextColorVariantClassNames, TColorVariant } from "../../style/colorVariants";

import "./_icon.scss";

export interface IIconProps extends Omit<IEworkitIconProps, "color"> {
  withCircle?: boolean;
  color?: TColorVariant;
}

export const Icon: FunctionComponent<IIconProps> = memo(props => {
  const colorVariant = props.color || "primary";
  const eworkitColor = colorVariant as TStyleTextColor;
  return (
    <EworkitIcon
      {...props}
      className={classNames(
        props.className,
        { "with-circle": !!props.withCircle },
        buildTextColorVariantClassNames(colorVariant),
      )}
      color={eworkitColor}
    />
  );
});
